var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom",value:('Status: ' + _vm.tooltipText),expression:"'Status: ' + tooltipText",modifiers:{"hover":true,"bottom":true}}],staticClass:"status-indicator",class:_vm.cssUsage})
}
var staticRenderFns = []

export { render, staticRenderFns }